module.exports = __webpack_public_path__ + "img/desire_003.c6bafe7.png";